import { useState, FC, useEffect } from "react";
import { v4 as uuidv4 } from 'uuid';
import { IEntitySimpleDTO } from "../../../../libs/coreapi-dto/@types/common";
import { GridSelectorModalWindow } from "../../../../components/modalWindows/GridSelectorModalWindow";
import { GoodsClassifierPluginSettings } from "../pluginSettings/GoodsClassifierPluginSettings";
import GoodsClassifierGrid from "../GoodsClassifierGrid";

export const GoodsClassifierSelectorModal: FC<IGridSelectorModalProps> = (props) => {
    const [entity, setEntity] = useState<IEntitySimpleDTO>(props.selectedEntity ?? {} as IEntitySimpleDTO)
    const [entities, setEntities] = useState<IEntitySimpleDTO[]>(props.selectedEntities ?? []);
    
    useEffect(() => {
        if (props.dataFromPluginGridSelectorInput)
            setEntities(props.dataFromPluginGridSelectorInput)
    }, [props.dataFromPluginGridSelectorInput])

    return (
        <GridSelectorModalWindow
            entityToPressEnter={entity}
            gridDisplayName={GoodsClassifierPluginSettings.name}
            ok={{
                onClick: () => {           
                    props.multipleSelect ? props.ok(entities) : props.ok?.(entity)
                },                
            }}
            cancel={{ onClick: () => props.cancel?.() }}
        >
            {
                GoodsClassifierPluginSettings ? (
                    <GoodsClassifierGrid 
                        gridId={uuidv4()}
                        dataFromPluginGridSelectorInput={props.dataFromPluginGridSelectorInput} 
                        plugin={GoodsClassifierPluginSettings} 
                        onSelect={(row) => row && setEntity({ idGlobal: row.idGlobal, displayName: row.displayName })}
                        onDoubleClick={(row) => {
                            setEntity({ idGlobal: row.idGlobal, displayName: row.displayName })
                            props.ok?.(entity)
                        }}
                        multipleSelect={props.multipleSelect}
                        onMultipleSelect={(rows) => {
                            rows && setEntities(rows.map(x => ({ idGlobal: x.idGlobal, displayName: x.displayName } as IEntitySimpleDTO)))
                        }}
                    />
                ) : ( 
                    <p> Справочник не настроен </p>
                )
            }
        </GridSelectorModalWindow>
    )
}